import { render, staticRenderFns } from "./ClientValidationForm.vue?vue&type=template&id=2d977f88"
import script from "./ClientValidationForm.vue?vue&type=script&lang=js"
export * from "./ClientValidationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports